import React, { useEffect, useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col,
    Container,
} from 'reactstrap';
  
import { toast } from 'react-toastify';

const VaccinationModalCancel = ({
    requestId,
    submitModal,
    closeModal,
    onComplete,
    modalIsOpen,
    className
}) => {

    const [value, setValue] = useState('')
    const [remarks, setRemarks] = useState('')

    useEffect(() => {
        setValue('')
        setRemarks('')
    }, [requestId])

    const handleChange = (event) => {
        const { value } = event.target
        setValue(value)
        setRemarks('')
    }

    const handleRemarksInputChange = (event) => {
        setRemarks(event.target.value)
    }

    const handleSubmit = () => {
        if(!value || !remarks) {
            return toast.error('No value/remark selected')
        }

        return submitModal(value, remarks)
        .then(() => {
            closeModal()
            onComplete()
        })
    }

    const getRemarksSelectOptions = () => {
        switch (value) {
            case "Doctor Unavailable": {
                return [ "",  "Profiling Error", "Doctor On Leave", "All slots booked", "Doctor went for emergency/IPD", "Corona", "Doctor Unavailable at requested location" ];
            }
            case "Doctor Couldn’t get onboarded": {
                return [ "", "doctor didn’t respond to our calls", "Denied 3rd party payment" ];
            }
            default:
                return [];
        }
    }

    return <Modal
        isOpen={modalIsOpen}
        toggle={closeModal}
        className={className}
    >
        <ModalHeader className="bg-primary" toggle={closeModal}>
            Sure you want to cancel? (Request Id: {requestId})
        </ModalHeader>
        <ModalBody>
            <Container>
                <Row>
                    <Col>
                        <Row>
                            <label>Reason for cancellation:</label>
                        </Row>
                        <br />
                        <Row>
                            <div>
                                <select onChange={handleChange} value={value}>
                                <option value="">Select Reason</option>
                                <option value="Slot was not available as per requirement">Slot was not available as per requirement</option>
                                <option value="Delayed confirmation from center">Delayed confirmation from center</option>
                                <option value="Paediatrician was not available">Paediatrician was not available</option>
                                <option value="User was looking for home visit only">User was looking for home visit only</option>
                                <option value="User was looking for center visit only">User was looking for center visit only</option>
                                <option value="User changed mind and will book later">User changed mind and will book later</option>
                                <option value="User already vaccinated against a different order">User already vaccinated against a different order</option>
                                <option value="Denial of service at the center">Denial of service at the center</option>
                                <option value="Location is unserviceable">Location is unserviceable</option>
                                <option value="Visit Demo">Visit Demo</option>
                                </select>
                            </div>
                        </Row>
                        <br />
                        <Row>
                            <div>
                                <React.Fragment>
                                {(getRemarksSelectOptions() && getRemarksSelectOptions().length) ? (
                                    <select value={remarks} onChange={handleRemarksInputChange}>
                                        {getRemarksSelectOptions().map((option) => (<option value={option}>{option || "Select Remark"}</option>))}
                                    </select>
                                ) : (
                                    <input onChange={handleRemarksInputChange} value={remarks} />
                                )}
                                </React.Fragment>
                            </div>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </ModalBody>
        <ModalFooter>
        <Button color="info" onClick={handleSubmit}>
            Cancel
        </Button>
        </ModalFooter>
    </Modal>
}

export default VaccinationModalCancel